// 引入封装后的请求实例
import request from '@/utils/request'
import utils from '@/utils/index.js'

export function checkIp(data) {
  return request({
    url: '/user/cfg/info', // 接口路径（拼接baseURL）
    method: 'get', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function me(data) {
  return request({
    url: '/user/base/me', // 接口路径（拼接baseURL）
    method: 'get', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
// 密码登录
export function login_password(data) {
  return request({
    url: '/user/base/login/password', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
// 验证码登录
export function login_code(data) {
  return request({
    url: '/user/base/login', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
// 获取验证码
export function getCode(data) {
  return request({
    url: '/user/base/send-check', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function register(data) {
  return request({
    url: '/user/base/register', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function change(data) {
  return request({
    url: '/user/base/password/change', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function checkPhone(data) {
  return request({
    url: '/user/base/check-phone', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function logout(data) {
  return request({
    url: '/user/base/logout', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function create(data) {
  return request({
    url: '/user/health/create', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function before_check(data, headers = {}, data2) {
  return request({
    url: '/user/health/before-check?' + utils.objectToUrlParams(data2), // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data, // post请求传参（放在请求体）
    headers: {
      ...headers
    }
  })
}
export function reset(data, headers = {}) {
  return request({
    url: '/user/base/password/reset', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
export function after_check(data, headers = {}) {
  return request({
    url: '/user/health/after-check', // 接口路径（拼接baseURL）
    method: 'post', // 请求方式：post/get/put/delete
    data, // post请求传参（放在请求体）
    headers: {
      ...headers
    }
  })
}
export function report(data) {
  return request({
    url: '/user/health/report?' + utils.objectToUrlParams(data), // 接口路径（拼接baseURL）
    method: 'get', // 请求方式：post/get/put/delete
    data // post请求传参（放在请求体）
  })
}
// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
    // get请求传参用params：params: { id: 123 }
  })
}

// 修改用户信息
export function updateUserInfo(data) {
  return request({
    url: '/user/update',
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/user/delete/${id}`, // 路径传参
    method: 'delete'
  })
}